import { siteConfig } from '@/mocks/site';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
                <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-lg font-bold">
                  {siteConfig.logo}
                </span>
                <span className="font-heading text-base font-semibold text-background-50">
                  {siteConfig.name}
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {siteConfig.description}
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                内容分类
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">关于我们</Link>
                </li>
                <li>
                  <Link to="/category/zixing-yanbian" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">字形演变</Link>
                </li>
                <li>
                  <Link to="/category/yuyi-jiexi" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">语义解析</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                联系我们
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line text-base"></i>
                  <span>{siteConfig.email}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-wechat-line text-base"></i>
                  <span>yinziyuan2024</span>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href={siteConfig.socialLinks.weibo} className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-600 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href={siteConfig.socialLinks.wechat} className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-600 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href={siteConfig.socialLinks.zhihu} className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-600 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="知乎" rel="nofollow">
                  <i className="ri-question-answer-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {siteConfig.foundingYear} - {new Date().getFullYear()} {siteConfig.name} 版权所有
            </p>
            <p className="text-xs text-foreground-500">
              专注汉字文化研究 | 弘扬中华优秀传统文化
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}